import React, { Fragment, useState, useEffect } from 'react';
import { Table, Container, Row, Col, Input, Spinner, Button, FormGroup, Label, Progress, FormFeedback, FormText } from "reactstrap";
import Contractor from '../../../assets/contractor.png';
import ContractorProfile from '../../../assets/contractor-profile.jpg';
import Dropdown from '../../../assets/dropdown.svg';
import Star from '../../../assets/star.svg';
import Envelope from '../../../assets/envelope-bitcoin.svg';
import '../../Steps/steps.scss';

function Sprint2Step5() {
	var divStyle = {
	  backgroundImage: 'url(' + Contractor + ')',
	};
    return (
    	<Fragment>
	        <nav id="topbar">
	    		<Container className="builde-cont">
			    	<Row>
		    			<Col xs={{size: 12}}>
		    				<div className="cont-topbar">
		    					<Button className="btn-back"></Button>
		    					<h3>Estimated budget</h3>
		    				</div>
		    			</Col>
			    	</Row>
		    	</Container>
	    	</nav>
	    	<section id="progress-bar">
	    		<Container className="builde-cont">
			    	<Row>
		    			<Col xs={{size: 12}}>
	    					<Progress value={32}></Progress>
		    			</Col>
			    	</Row>
		    	</Container>
	    	</section>
	    	<form className="m-t-20 form-base-dis">
	    		<Container className="builde-cont">
			    	<Row>
		    			<Col xs={{size: 12}}>
		    				<h1>Request <br/>contractor visit</h1>

		    				<span className="text-label m-t-20">Select up to 5 contractors</span>
		    			</Col>
			    	</Row>
		    	</Container>

		    	<section className="m-t-12 carousel-container">
			        <div className="carousel-options filters">
			            <div className="item-select selected">
			            	<span className="dropdown">
			            	Sort by
			            	<img src={Dropdown}/>
			            	</span>
			            </div>
			            <div className="item-select checked">
			            	<span>Fast response</span>
			            </div>
			            <div className="item-select">
			            	<span>+4.5</span>
			            </div>
			            <div className="item-select">
			            	<span>Sort by</span>
			            </div>
			            <div className="item-select">
			            	<span>Sort by</span>
			            </div>
			            <div className="item-select">
			            	<span>Sort by</span>
			            </div>
			        </div>
			    </section>

	    		<Container className="builde-cont">
		    		<Row>
		    			<Col xs="{{size: 12}}">
		    				<section id="contractors-grid" className="m-t-10">
		    					<div className="contractor-item">
									<Input type="checkbox" id="contractor1"/>
									<Label check for="contractor1"></Label>
									<div className="cont-img" style={divStyle}>
									</div>
									<div className="cont-text">
										<img className="profile" src={ContractorProfile}/>
										<div>
											<h4>Contractor company</h4>
											<span className="certificated">Certificated</span>
											<span className="reviews">35 reviews</span>
										</div>
										<span className="rate ok">
											<img src={Star} className="contractorimg"/>4.5
										</span>
									</div>
		    					</div>
		    					<div className="contractor-item">
									<Input type="checkbox" id="contractor4"/>
									<Label check for="contractor4"></Label>
									<div className="cont-img" style={divStyle}>
									</div>
									<div className="cont-text">
										<img className="profile" src={ContractorProfile}/>
										<div>
											<h4>Contractor company</h4>
											<span className="certificated">Certificated</span>
											<span className="reviews">35 reviews</span>
										</div>
										<span className="rate ok">
											<img src={Star} className="contractorimg"/>4.5
										</span>
									</div>
		    					</div>
		    					<div className="contractor-item">
									<Input type="checkbox" id="contractor2"/>
									<Label check for="contractor2"></Label>
									<div className="cont-img" style={divStyle}>
									</div>
									<div className="cont-text">
										<img className="profile" src={ContractorProfile}/>
										<div>
											<h4>Contractor company</h4>
											<span className="certificated">Certificated</span>
											<span className="reviews">35 reviews</span>
										</div>
										<span className="rate ok">
											<img src={Star} className="contractorimg"/>4.5
										</span>
									</div>
		    					</div>
		    					<div className="contractor-item">
									<Input type="checkbox" id="contractor3"/>
									<Label check for="contractor3"></Label>
									<div className="cont-img" style={divStyle}>
									</div>
									<div className="cont-text">
										<img className="profile" src={ContractorProfile}/>
										<div>
											<h4>Contractor company</h4>
											<span className="certificated">Certificated</span>
											<span className="reviews">35 reviews</span>
										</div>
										<span className="rate ok">
											<img src={Star} className="contractorimg"/>4.5
										</span>
									</div>
		    					</div>
		    				</section>
		    			</Col>
		    		</Row>	
		    	</Container>

		    	{/*BTN SAVE DRAFT & SELECT TO CONTINUE*/}
    			{/*<section id="bottom-sticky">
    				<Button color="secondary" size="lg">Save draft</Button>
    				<Button color="primary" size="lg">Select to continue</Button>
    			</section>*/}

    			<section id="bottom-sticky">
    				<Button color="primary" size="lg" className="w-100">Send request <span className="request-count">2/5</span></Button>
    			</section>

    			{/*MODAL*/}
    			<section className="modal-from-bottom">
    				<div className="backshadow"></div>
    				<div className="modal-content">
    					<Container className="builde-cont">
    						<Row>
								<Col xs={{size: 12}} className="text-center">
									<img src={Envelope} />
									<h4>Would you like to receive quotes from other interested contractors to fill your 5 quotas?</h4>

									<Button color="primary" size="lg">Fine for me</Button>
									<Button color="secondary" size="lg" className="m-t-15">No thanks</Button>
								</Col>
    						</Row>
    					</Container>
    				</div>
    			</section>
	    	</form>
    	</Fragment>
    );
}

export default Sprint2Step5;